// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"TagsFilter__cursor-pointer--tHkLCQyB"};